/* eslint-disable max-len */
import React from 'react'
import DashboardDetailsShimmer from '../../../components/Shimmer/DashboardDetailsShimmer'

function ApplicationDetails({loadingDetails, graphDetails}) {
    return (
        loadingDetails ?
            (<DashboardDetailsShimmer />)
            :
            (<div className='w-full flex flex-wrap items-center px-6 pt-8'>
                <div className='w-1/4'>
                    <p className='font-normal text-xs text-[#8E8E8E]'>Number of Products with no NFT</p>
                    <p className='mt-2 font-medium text-[#1F1F1F] text-[30px]' data-testid="no-nft-value">{graphDetails?.products_with_no_nft}</p>
                </div >
                <div className='w-1/4'>
                    <p className='font-normal text-xs text-[#8E8E8E]'>Number of Stores</p>
                    <p className='mt-2 font-medium text-[#1F1F1F] text-[30px]' data-testid="no-carts">{graphDetails?.number_of_stores}</p>
                </div>
                <div className='w-1/4'>
                    <p className='font-normal text-xs text-[#8E8E8E]'>Number of Products Scanned</p>
                    <p className='mt-2 font-medium text-[#1F1F1F] text-[30px]' data-testid="no-scanned-products">{graphDetails?.number_of_products_scanned}</p>
                </div>
                <div className='w-1/4'>
                    <p className='font-normal text-xs text-[#8E8E8E]'>Number of Products</p>
                    <p className='mt-2 font-medium text-[#1F1F1F] text-[30px]' data-testid="no-of-products">{graphDetails?.number_of_products}</p>
                </div>
                <div className='w-1/4 mt-[60px]'>
                    <p className='font-normal text-xs text-[#8E8E8E]'>Number of Orders Completed</p>
                    <p className='mt-2 font-medium text-[#1F1F1F] text-[30px]' data-testid="no-of-orders">{graphDetails?.number_of_orders}</p>
                </div>
                <div className='w-1/4 mt-[60px]'>
                    <p className='font-normal text-xs text-[#8E8E8E]'>Number of Checkouts</p>
                    <p className='mt-2 font-medium text-[#1F1F1F] text-[30px]' data-testid="online-checkout">{graphDetails?.number_of_online_checkouts}</p>
                </div>
                <div className='w-1/4 mt-[60px]'>
                    <p className='font-normal text-xs text-[#8E8E8E]'>Number of Cryptocurrency Payments</p>
                    <p className='mt-2 font-medium text-[#1F1F1F] text-[30px]' data-testid="crypto-payments">{graphDetails?.number_of_crypto_payments}</p>
                </div>
                <div className='w-1/4 mt-[60px]'>
                    <p className='font-normal text-xs text-[#8E8E8E]'>No of Carts Created</p>
                    <p className='mt-2 font-medium text-[#1F1F1F] text-[30px]' data-testid="no-carts">{graphDetails?.number_of_carts}</p>
                </div>
                <div className='w-1/4 mt-[60px]'>
                    <p className='font-normal text-xs text-[#8E8E8E]'>Number of Carts Cleared</p>
                    <p className='mt-2 font-medium text-[#1F1F1F] text-[30px]' data-testid="carts-cleared" >{graphDetails?.number_of_carts_cleared}</p>
                </div>
            </div >)
    )
}

export default ApplicationDetails